<template>
  <FormGroup>
    <RadioButtonGroup>
      <RadioButton v-model="form.fields.isUtilitiesIncludedInRent" name="isUtilitiesIncludedInRent" :value="true">
        Has utilities included
      </RadioButton>
      <RadioButton v-model="form.fields.isUtilitiesIncludedInRent" name="isUtilitiesIncludedInRent" :value="false">
        No utilities included
      </RadioButton>
    </RadioButtonGroup>

    <template v-if="form.fields.isUtilitiesIncludedInRent">
      <Divider />

      <FormGroup>
        <FormField
          v-for="[key, value] in includedUtilitiesMap"
          :key="key"
          :label="value"
          direction="row"
          :error="form.fieldErrors(key)"
        >
          <CheckmarkCrossmark v-model="form.fields[key]" />
        </FormField>
      </FormGroup>
    </template>
  </FormGroup>
</template>

<script setup lang="ts">
import {
  CheckmarkCrossmark,
  Divider,
  FormField,
  FormGroup,
  RadioButton,
  RadioButtonGroup,
  useForm,
} from '@tallo/design-system';
import { includedUtilitiesMap } from '@tallo/property';

import { SaveIncludedUtilitiesDto } from '../../dtos/save-included-utilities.dto.interface';
import { usePropertyStore } from '../../stores/property.store';

const propertyStore = usePropertyStore();
const form = useForm<SaveIncludedUtilitiesDto>({
  ...getUtilities(),
  isUtilitiesIncludedInRent: true,
});

function getUtilities() {
  const form = Array.from(includedUtilitiesMap).map(([key]) => [
    key,
    propertyStore.property?.includedUtilities?.[key] ?? null,
  ]);

  return Object.fromEntries(form);
}

async function save() {
  return await form.submit((fields) => propertyStore.saveIncludedUtilities(fields));
}

defineExpose({ save, form });
</script>
